/*
 * Copyright 2025 Mifos Initiative
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/openMF/kmp-project-template/blob/main/LICENSE
 */
package kpt.feature.home.di

import kpt.feature.home.demo.ui.HomeViewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module

/**
 * Koin bindings for the home feature. Picked up by the generated feature-module aggregate, so
 * removing the feature removes the module with it.
 */
val HomeModule = module {
    // demo:begin
    viewModelOf(::HomeViewModel)
    // demo:end
}
